import { defineStore } from "pinia";
import { useState } from "@erp/shared/composables";
export const useProjectStore = defineStore("useProjectStore", () => {
    const [clickedProjectId, setClickedProjectId] = useState(null);
    return {
        clickedProjectId,
        setClickedProjectId,
    };
});
